import React from 'react';
import { BarChart3 } from 'lucide-react';
import { InventoryPage } from './inventory/InventoryChrome';
import { WebAnalyticsDashboard } from '../components/web-analytics/WebAnalyticsDashboard';
import { adminWebAnalyticsApi } from '../services/webAnalyticsApi';

/**
 * /analytics — Website Analytics (spec 2026-10-06). Replaces the old revenue
 * page (owner-approved mockup docs/superpowers/mockups/2026-10-05-website-analytics.html).
 * The dashboard itself lives in components/web-analytics and is shared with
 * platform-app; this page only supplies the admin API adapter and the chrome.
 */
const SuperAdminAnalytics: React.FC = () => (
  <WebAnalyticsDashboard
    mode="admin"
    api={adminWebAnalyticsApi}
    chrome={({ subtitle, actions, tabs, children }) => (
      <InventoryPage icon={BarChart3} title="Website Analytics" crumb="Analytics" subtitle={subtitle} actions={actions} tabs={tabs} wide>
        <div className="max-w-[1440px] mx-auto">{children}</div>
      </InventoryPage>
    )}
  />
);

export default SuperAdminAnalytics;
